import { gql } from '@apollo/client';

import { CAMPAIGN_TRAFFICKING_COLUMNS } from '../fragments';

export const GET_CAMPAIGNS = gql`
  query GET_CAMPAIGNS(
    $filterOptions: CampaignFilterOptionsV5
    $sort: CampaignSortOptionV5
    $order: OrderOption
    $limit: Int
    $offset: Int
  ) {
    campaigns: campaignsV5(
      filterOptions: $filterOptions
      sortOptions: { sort: $sort, order: $order }
      paginationOptions: { limit: $limit, offset: $offset }
    ) {
      edges {
        node {
          ...campaignTraffickingColumns
        }
      }
      total
    }
    getCurrencyPrecisions {
      code
      decimals
    }
  }
  ${CAMPAIGN_TRAFFICKING_COLUMNS}
`;
